import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { SortDirection } from '@e-origin/shared';

import { CommentCreateDataSchema, CommentEditDataSchema, CommentListItemSchema } from './schemas';

const c = initContract();

export const commentContract = c.router({
  retrieveComments: {
    method: 'POST',
    path: '/comments',
    body: z.object({
      criteria: z
        .object({
          filters: z.object({
            filterByEntityId: z.array(z.string()).optional(),
            filterByEntityParentId: z.array(z.string()).optional(),
          }),
          sorting: z.object({ field: z.string(), direction: z.enum([SortDirection.ASC, SortDirection.DESC]) }),
          includeUserDetails: z.boolean().optional(),
        })
        .optional(),
    }),
    responses: {
      200: z.object({
        data: z.object({
          list: z.array(CommentListItemSchema),
          totalItems: z.number(),
          userMap: z.record(z.string()).optional(),
        }),
      }),
    },
  },
  createComment: {
    method: 'POST',
    path: '/comment/add',
    body: CommentCreateDataSchema,
    responses: {
      200: z.object({
        message: z.string(),
      }),
    },
  },
  updateComment: {
    method: 'PATCH',
    path: '/comment/:commentId',
    body: CommentEditDataSchema,
    responses: {
      200: z.object({
        message: z.string(),
      }),
    },
  },
  deleteComment: {
    method: 'DELETE',
    path: '/comment/:commentId',
    body: c.noBody(),
    pathParams: z.object({ commentId: z.string() }),
    responses: {
      204: z.object({}),
    },
  },
});
